import { supabase } from "@/lib/supabase";
import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, select, takeEvery } from "redux-saga/effects";

import {
  fetchResponses,
  fetchResponsesSuccess,
  fetchResponsesFailure,
  setResponsesLoading,
  fetchResponsesModel,
  fetchResponsesPrompt,
  fetchResponsesPromptSuccess,
  fetchResponsesModelSuccess,
} from "./slice";
import { applySagaError } from "../utils/saga";
import { throwOnSupabaseError } from "../../utils/errors";
import { 
  FetchResponsesPayload, 
  FetchResponsesPromptPayload, 
  FetchResponsesModelPayload
} from "./types";
import { selectAuthAccountId } from "../selectors/auth";
import { RESPONSES_TABLE_NAME } from "../const";



export function* fetchResponsesSaga(action: PayloadAction<FetchResponsesPayload>) {
  try {
    yield put(setResponsesLoading());
    const { date } = action.payload;
    const userID: string | null = yield select(selectAuthAccountId);

    const { data, error } = yield call(() =>
      supabase
        .from(RESPONSES_TABLE_NAME)
        .select('*')
        .eq('user_id', userID)
        .gte('created_at', `${date}T00:00:00`)
        .lte('created_at', `${date}T23:59:59`)
        .order('created_at', { ascending: true })
    );

    throwOnSupabaseError(error);

    yield put(fetchResponsesSuccess(data));
    
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "response.fetchResponses",
      failureAction: fetchResponsesFailure,
    });
  }
}



export function* fetchResponsesPromptSaga(action: PayloadAction<FetchResponsesPromptPayload>) {
  try {
    yield put(setResponsesLoading());
    const { date, prompt_id, brand_ids } = action.payload;
    const userID: string | null = yield select(selectAuthAccountId);

    const { data, error } = yield call(() =>
      supabase
        .from(RESPONSES_TABLE_NAME)
        .select('*')
        .eq('user_id', userID)
        .eq('prompt_id', prompt_id)
        .in('brand_id', brand_ids)
        .gte('created_at', `${date}T00:00:00`)
        .lte('created_at', `${date}T23:59:59`)
        .order('created_at', { ascending: true })
    );

    throwOnSupabaseError(error);

    yield put(fetchResponsesPromptSuccess(data));
    
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "response.fetchResponsesByPrompt",
      failureAction: fetchResponsesFailure,
    });
  }
}



export function* fetchResponsesModelSaga(action: PayloadAction<FetchResponsesModelPayload>) {
  try {
    yield put(setResponsesLoading());
    const { date, model_id, brand_ids } = action.payload;
    const userID: string | null = yield select(selectAuthAccountId);

    const { data, error } = yield call(() =>
      supabase
        .from(RESPONSES_TABLE_NAME)
        .select('*')
        .eq('user_id', userID)
        .eq('model_id', model_id)
        .in('brand_id', brand_ids)
        .gte('created_at', `${date}T00:00:00`)
        .lte('created_at', `${date}T23:59:59`)
        .order('created_at', { ascending: true })
    );

    throwOnSupabaseError(error);

    yield put(fetchResponsesModelSuccess(data));
    
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "response.fetchResponsesByModel",
      failureAction: fetchResponsesFailure,
    });
  }
}



export function* responsesSaga() {
  yield takeEvery(fetchResponses.type, fetchResponsesSaga);
  yield takeEvery(fetchResponsesPrompt.type, fetchResponsesPromptSaga);
  yield takeEvery(fetchResponsesModel.type, fetchResponsesModelSaga);
}